import script from "./editLiveCate.vue?vue&type=script&lang=ts&setup=true"
export * from "./editLiveCate.vue?vue&type=script&lang=ts&setup=true"

import "./editLiveCate.vue?vue&type=style&index=0&id=a6111626&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6111626"]])

export default __exports__